// src/components/ThemeSettingsButton.tsx - ADMIN-ONLY VERSION
import React, { useState } from 'react';
import { IconButton, Tooltip, Badge } from '@mui/material';
import { Palette as PaletteIcon } from '@mui/icons-material';
import ThemeSettingsDialog from './ThemeSettingsDialog';
import { useThemeContext } from '../contexts/ThemeContext';

const ThemeSettingsButton: React.FC = () => {
  const [open, setOpen] = useState(false);
  const { customColors, canEditTheme } = useThemeContext();

  // Only show button if user can edit theme (admins only)
  // OR show to all users but make it view-only in the dialog
  // Choose one approach:
  
  // OPTION 1: Hide button completely for non-admins (uncomment to use)
  // if (!canEditTheme) {
  //   return null;
  // }

  // OPTION 2: Show button to everyone but dialog is read-only for non-admins (current)
  return (
    <>
      <Tooltip title={canEditTheme ? "Theme Settings (Admin)" : "View Theme Settings"}>
        <IconButton
          color="inherit"
          onClick={() => setOpen(true)}
          size="large"
        >
          <Badge
            color="secondary"
            variant="dot"
            invisible={!customColors}
          >
            <PaletteIcon />
          </Badge>
        </IconButton>
      </Tooltip>
      <ThemeSettingsDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default ThemeSettingsButton;